import { LoggedOutBlueWaveTemplateJsm } from "../components/logged-out-blue-wave-template-jsm";

import { useIntl } from "react-intl";

export const LoggedOutJsmPremium = () => {
    const { formatMessage } = useIntl();
    return (
        <LoggedOutBlueWaveTemplateJsm
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
